import { render, staticRenderFns } from "./enduranceSetting.vue?vue&type=template&id=491fc018&scoped=true"
import script from "./enduranceSetting.vue?vue&type=script&lang=js"
export * from "./enduranceSetting.vue?vue&type=script&lang=js"
import style0 from "./enduranceSetting.vue?vue&type=style&index=0&id=491fc018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491fc018",
  null
  
)

export default component.exports